import debounce from 'lodash/debounce';
import React, { useContext, useMemo, useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';

import { CInput, CSelect } from '../../../../../../../migration/CInput';
import CTooltip from '../../../../../../../migration/CTooltip';
import { EXIST_OPERATOR_VALUES } from '../../../../../../../../constants';
import { FormCrawlTableContext } from '../FormCrawlRuleTable';

const CustomInput = ({ value, onChangeInput, disableCell, ...rest }) => {
     const [inputValue, setInputValue] = useState(value);

     const onChange = (e) => {
          const { value } = e.target;
          setInputValue(value);
          onChangeInput(value);
     };

     useMemo(() => setInputValue(value), [value]);

     return (
          <CInput
               value={inputValue}
               onChange={onChange}
               autoComplete="off"
               data-lpignore="true"
               disabled={disableCell}
               style={disableCell ? { backgroundColor: '#c8ced3' } : {}}
               {...rest}
          />
     );
};

const Row = (props) => {
     const { row, rowIndex, setTableRow, setRemoveRowModal, resetBtnSaveStatus, handleChangeRowData } = props;
     const variableTypes = ['FormCategory'];

     const handleRemoveRow = (index) => {
          setTableRow((prevTableRow) => {
               let data = [...prevTableRow];
               let flag = false;
               flag = data[index].conditions.some((condition) => {
                    if (condition.g0.value !== '') {
                         return true;
                    }
                    return false;
               });
               if (flag === true) {
                    setRemoveRowModal({ show: true, index });
               } else if (data.length > 1) {
                         data.splice(index, 1);
                         return data;
                    }

               return prevTableRow;
          });

          resetBtnSaveStatus();
     };

     const onChangeInput = debounce((value, type, rowIndex, colIndex) => {
          handleChangeRowData(value, type, rowIndex, colIndex);
     }, 200);

     return (
          <Draggable key={rowIndex} draggableId={rowIndex.toString()} index={rowIndex}>
               {(provided, snapshot) => (
                    <tr
                         className={`table-body ${snapshot.isDragging ? 'isDragging' : ''}`}
                         ref={provided.innerRef}
                         {...provided.draggableProps}
                         {...provided.dragHandleProps}
                    >
                         {row?.conditions?.map((col, colIndex) => {
                              const conditionValues = col.g0;
                              const disableCell = EXIST_OPERATOR_VALUES.includes(conditionValues.operator);
                              const allowShowVariable = variableTypes.indexOf(conditionValues.type) > -1;
                              if (!allowShowVariable) <React.Fragment key={colIndex} />;

                              if (conditionValues.key === 'Match Type') {
                                   return (
                                        <td key={colIndex} className="event-variable-value variable-column">
                                             <CSelect
                                                  name="variable"
                                                  className="rounded-0"
                                                  value={conditionValues.value}
                                                  onChange={(e) => onChangeInput(e.target.value, 'conditions', rowIndex, colIndex)}
                                             >
                                                  <option value="formId">ID</option>
                                                  <option value="formClass">Class</option>
                                             </CSelect>
                                        </td>
                                   );
                              }

                              return (
                                   <td key={colIndex} className="event-variable-value variable-column event-variable-value-ellipsis">
                                        {colIndex === 0 && (
                                             <span>
                                                  <i className="fas fa-ellipsis-v" />
                                             </span>
                                        )}
                                        {((colIndex === 0 || colIndex === 2) && conditionValues.value.trim().length >= 60) ? (
                                             <CTooltip maxWidth={400} content={conditionValues.value} placement="top">
                                                  <CustomInput
                                                       name="variable"
                                                       className="rounded-0"
                                                       value={conditionValues.value}
                                                       onChangeInput={(value) => onChangeInput(value, 'conditions', rowIndex, colIndex)}
                                                       disableCell={disableCell}
                                                  />
                                             </CTooltip>
                                        ) : (
                                             <CustomInput
                                                  name="variable"
                                                  className="rounded-0"
                                                  value={conditionValues.value}
                                                  onChangeInput={(value) => onChangeInput(value, 'conditions', rowIndex, colIndex)}
                                                  disableCell={disableCell}
                                             />
                                        )}
                                   </td>
                              );
                         })}

                         <td key={rowIndex} className="btn-remove-row">
                              <CTooltip content="Remove row" placement="bottom-start">
                                   <i className="fal fa-times text-danger" onClick={() => handleRemoveRow(rowIndex)}></i>
                              </CTooltip>
                         </td>
                    </tr>
               )}
          </Draggable>
     );
};

const TableBodyRows = () => {
     const theContext = useContext(FormCrawlTableContext);
     const { tableRow } = theContext;

     return <>{tableRow?.map((row, rowIndex) => <Row key={rowIndex} row={row} rowIndex={rowIndex} {...theContext} />)}</>;
};

export default TableBodyRows;
